// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-homepage-body-variations-tsx": () => import("./../../../src/pages/homepage-body-variations.tsx" /* webpackChunkName: "component---src-pages-homepage-body-variations-tsx" */),
  "component---src-templates-news-year-tsx": () => import("./../../../src/templates/news-year.tsx" /* webpackChunkName: "component---src-templates-news-year-tsx" */),
  "component---src-templates-single-page-tsx": () => import("./../../../src/templates/single/Page.tsx" /* webpackChunkName: "component---src-templates-single-page-tsx" */),
  "component---src-templates-single-post-tsx": () => import("./../../../src/templates/single/Post.tsx" /* webpackChunkName: "component---src-templates-single-post-tsx" */)
}

